<div class="line-inputs" fxLayout="column" fxLayoutAlign="space-between stretch" fxFill>
  <form [formGroup]="lineItemsForm" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
    <dashboard-module-item-core [dialogData]="dialogData" formControlName="moduleItemCore"></dashboard-module-item-core>
    <div fxLayout="column" fxLayoutAlign="space-between stretch">
      <mat-form-field>
        <input type="number" matInput formControlName="maxChars" placeholder="Maximum number of characters" />
        <mat-error *ngIf="maxChars.hasError('required')">
          Max number of characters is <strong>required</strong>.
        </mat-error>
        <mat-error *ngIf="maxChars.hasError('min')"> Max number of characters needs to be greater than 0. </mat-error>
      </mat-form-field>
    </div>
    <div
      class="line-inputs__actions"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
    >
      <button mat-raised-button color="primary" (click)="closeModuleItemDialog()">
        {{ 'Cancel' | uppercase }}
      </button>
      <button mat-raised-button color="primary" (click)="saveModuleItem()">
        {{ 'Save' | uppercase }}
      </button>
    </div>
  </form>
</div>
